module.exports = __webpack_public_path__ + "static/media/arrow-off-noroeste.e6b04db6.png";